import { Link } from 'react-router-dom';

const services = [
  { label: 'All Services', to: '/services' },
  { label: '1-2-1 Personal Training', to: '/personal-training' },
  { label: 'Bespoke Online Coaching', to: '/online-training' },
  { label: 'Nutritional Coaching', to: '/nutritional-coaching' },
];

const links = [
  { label: 'About', to: '/about' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1c1917]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <span className="text-white text-2xl font-bold tracking-[0.15em] block" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                LAURA MARTIN
              </span>
              <span className="text-white/30 text-[9px] tracking-[0.4em] uppercase font-sans mt-0.5 block">
                FITNESS &amp; COACHING
              </span>
            </Link>
            <p className="text-white/45 text-sm leading-relaxed max-w-[200px] font-sans">
              Premium personal training &amp; nutrition coaching in London.
            </p>
            <a
              href="https://www.instagram.com/wee_lola_fit"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 mt-6 group"
            >
              <span className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/40 group-hover:border-[#c9a96e] group-hover:text-[#c9a96e] transition-all duration-300">
                <i className="ri-instagram-line text-base" />
              </span>
              <span className="text-white/40 text-xs font-sans group-hover:text-[#c9a96e] transition-colors duration-300">@wee_lola_fit</span>
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white/30 text-[9px] tracking-[0.35em] uppercase font-sans font-semibold mb-6">Services</h4>
            <ul className="flex flex-col gap-3">
              {services.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} className="text-white/55 text-sm font-sans hover:text-[#c9a96e] transition-colors duration-300">{s.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white/30 text-[9px] tracking-[0.35em] uppercase font-sans font-semibold mb-6">Navigate</h4>
            <ul className="flex flex-col gap-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/55 text-sm font-sans hover:text-[#c9a96e] transition-colors duration-300">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/30 text-[9px] tracking-[0.35em] uppercase font-sans font-semibold mb-6">Get In Touch</h4>
            <a href="mailto:lauramartinfitness@gmail.com" className="text-white/55 text-sm font-sans hover:text-[#c9a96e] transition-colors duration-300 block mb-3 break-all">
              lauramartinfitness@gmail.com
            </a>
            <p className="text-white/30 text-sm font-sans mb-5">London, UK</p>
            <Link
              to="/contact"
              className="inline-block px-5 py-2.5 border border-[#c9a96e]/40 text-[#c9a96e] text-[10px] font-sans font-bold tracking-[0.25em] uppercase rounded-full hover:bg-[#c9a96e] hover:text-white hover:border-[#c9a96e] transition-all duration-300"
            >
              Free Consultation
            </Link>
          </div>
        </div>

        <div className="border-t border-white/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-white/25 text-xs font-sans">© {new Date().getFullYear()} Laura Martin Fitness. All rights reserved.</span>
          <span className="text-white/15 text-xs font-sans tracking-widest uppercase">London · UK</span>
        </div>
      </div>
    </footer>
  );
}
